import React, { useEffect } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { Stack } from '@fiverr-private/layout_components';
import { localStorage } from '@fiverr-private/futile';
import { getAnnouncementsLastSeenKey } from '@fiverr-private/go_shared_ui';
import { Announcement } from '../../../types/announcement.types';
import Announcements from '../../components/Announcements/Announcements';
import { HeaderNavigation } from '../../components/HeaderNavigation';

const App = ({ announcements, goSidebarProps }: { announcements: Announcement[]; goSidebarProps }) => {
    useEffect(() => {
        const { userId, userGuid } = getContext();
        localStorage.set(getAnnouncementsLastSeenKey({ userId, userGuid }), new Date());
    }, []);

    return (
        <Stack
            gap="0"
            style={{ minHeight: '100dvh' }}
            minHeight="100vh"
            height="100%"
            display="flex"
            background="rgba(12, 12, 13, 1)"
        >
            <Stack style={{ height: '100dvh' }} height="100vh" position="fixed">
                <HeaderNavigation showCreateTab={goSidebarProps.showCreateTab} showHubTab={goSidebarProps.showHubTab} />
            </Stack>
            <Stack
                flex="1"
                marginLeft={{ default: '0', sm: '24' }}
                marginTop={{ default: '16', sm: '0' }}
                paddingX={{ default: '4', md: '6', lg: '20' }}
            >
                <Announcements announcements={announcements} />
            </Stack>
        </Stack>
    );
};

export default App;
